import { Inject, Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import * as Forge from "node-forge";

@Injectable({
  providedIn: "root",
})
export class EncryptionService {
  // aesKey = "hrhk"; // 128 bits (16 bytes) AES key
  // aesIV = "hrhk";
  aesIV = CryptoJS.lib.WordArray.random(16);
  aesKey = CryptoJS.lib.WordArray.random(16);
  private rsaKey: any;
  private publicKey = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArmWa26AIjq/OYz8NPZV0
    AkM55lJaIQ0ltcJjjvgNdiQe3W9egUxuLOJBRnPdXVnlxNMWb6Yi59nKFPQPGMO4
    wWYrvg+SgXXRRNPi1fOUqYH9rFbUvo3U/W3MCdJD7G9C73DQNLQ0q2pg8YwqxQGt
    5sgT+MAXuuxWRX+s0woKZWMjRncYivhKiYOo6T/DRWSwPLSaX+cBem4aUfrJtXTN
    SvhUv8DzJLpE0zxHXNAo3/lb9otX+1exQXROl8DoEXLoaOzFYFHXW5YEcVa5IA5c
    UN8V68L1YoJuGTnwddpgRwCi7X6sADXzRnIcRr9Mf4wyei2C4ByoC7xcyF5urt1k
    VQIDAQAB
    -----END PUBLIC KEY-----
    `;

  constructor() {}

  encryptRSA(aesKey: string, aesIv: string) {
    const rsaPublicKey = Forge.pki.publicKeyFromPem(this.publicKey);
    const aesKeyBytes = Forge.util.decode64(aesKey);
    const aesIVBytes = Forge.util.decode64(aesIv);

    const encryptedAesKey = rsaPublicKey.encrypt(aesKeyBytes, "RSA-OAEP");
    const encryptedAesIV = rsaPublicKey.encrypt(aesIVBytes, "RSA-OAEP");

    return {
      encryptedAesKey: Forge.util.encode64(encryptedAesKey),
      encryptedAesIV: Forge.util.encode64(encryptedAesIV),
    };
  }

  async encryptAES(data: string) {

    // Encrypt data using AES
    const encryptedData = CryptoJS.AES.encrypt(
      data,
      this.aesKey.toString(),
      { iv: this.aesIV }
    ).toString();
    

    const rsaPublicKey = Forge.pki.publicKeyFromPem(this.publicKey);
    const aesKeyBytes = Forge.util.createBuffer(this.aesKey.toString());
    const aesIVBytes = Forge.util.createBuffer(this.aesIV.toString());
    

    const encryptedAesKey = rsaPublicKey.encrypt(aesKeyBytes.getBytes(), "RSA-OAEP");
    const encryptedAesIV = rsaPublicKey.encrypt(aesIVBytes.getBytes(), "RSA-OAEP");

    return {
      encryptedData,
      encryptedAesKey: Forge.util.encode64(encryptedAesKey),
      encryptedAesIV: Forge.util.encode64(encryptedAesIV),
    };
  }
}
